module.exports = __webpack_public_path__ + "static/media/boipa.2b040a98.jpeg";